import React from 'react';
import { useIntl } from 'react-intl';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';

// Modal de confirmação de discagem — evita ligações por clique acidental (discar é crítico).
// Reutilizável em todos os locais que disparam ligação. onConfirm/onClose controlados pelo pai.
export default function VoipDialConfirm({ open, number, providerName, onConfirm, onClose }) {
  const intl = useIntl();
  const f = (id, def, values) => intl.formatMessage({ id, defaultMessage: def }, values);

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.25, pb: 1 }}>
        <Box sx={{ width: 38, height: 38, borderRadius: '50%', bgcolor: 'var(--mexx-green-light, #E4F0D4)', color: 'var(--mexx-green-dark, #558B2F)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <PhoneIcon sx={{ fontSize: 20 }} />
        </Box>
        <span style={{ fontSize: 17, fontWeight: 700, color: '#0f172a' }}>{f('voip.dial.confirm.title', 'Confirmar ligação')}</span>
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography sx={{ fontSize: 14.5, color: '#334155' }}>
          {f('voip.dial.confirm.msg', 'Deseja realizar a ligação para o número {number} agora?', { number: <b style={{ color: '#0f172a' }}>{number}</b> })}
        </Typography>
        {providerName ? (
          <Typography sx={{ fontSize: 11.5, color: '#94a3b8', mt: 0.85 }}>
            {f('voip.dial.confirm.via', 'A ligação será feita via {provider}.', { provider: providerName })}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: '#64748b', textTransform: 'none' }}>{f('voip.dial.confirm.cancel', 'Cancelar')}</Button>
        <Button variant="contained" disableElevation startIcon={<PhoneIcon sx={{ fontSize: 17 }} />} onClick={onConfirm}
          sx={{ bgcolor: 'var(--mexx-green-primary, #8BC34A)', textTransform: 'none', '&:hover': { bgcolor: 'var(--mexx-green-dark, #7CB342)' } }}>
          {f('voip.dial.confirm.ok', 'Ligar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
